import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getCompanyList, getMasterPolicyList, removeCompany, removeMasterPolicy } from "../../../services/ApiService";
import { api } from "../../../utils/api";
import { goToPage, promptMessage } from "../../../utils/functions";
import { translate } from "../../../utils/translate";
import CustomTable from "../../components/CustomTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const CompanyList = (props) => {
    const lang = props.lang;
    const history = useHistory();
    const location = useLocation();
     const [filterInput, setFilterInput] = useState(""); 
    const [pageNumber, setPageNumber] = useState(1);
    const [productPerpage, setProductPerpage] = useState(10);
    const tableColumns = [
        {
            Header: translate(lang, 'index'),
            accessor: (row, index) => {
                return index + 1;
            }
        },
        {
            Header: translate(lang, 'companyName'),
            accessor: (row, index) => {
                return row.companyName;
            }
        },
        {
            Header: translate(lang, 'companyCode'),
            accessor: (row, index) => {
                return row.term.toUpperCase();
            }
        },
        {
            Header: translate(lang, 'remark'),
            accessor: (row, index) => {
                return row.remark;
            }
        },
        {
            Header: translate(lang, 'companyLogo'),
            accessor: (row, index) => {
                return <><img src={`${api.companyLogo + "/" + row.logo}`} alt="icon" width="50px" height="50px"></img></>;
            }
        },
        {
            Header: translate(lang, 'action'),
            accessor: (row, index) => {
                return (<>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">{translate(props.lang, "View Company")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/company/view/${row.id}`, pageNumber, productPerpage, filterInput)}
                                // to={`/company/view/${row.id}`}
                                className="btn btn-primary shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-eye"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-3">{translate(props.lang, "Edit Company Info")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                // to={`/company/edit/${row.id}`}
                                onClick={()=>goToPage(`/company/edit/${row.id}`, pageNumber, productPerpage, filterInput)}
                                className="btn btn-warning shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-pen"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-4">{translate(props.lang, "Delete Company")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <span
                                ref={ref} {...triggerHandler}
                                onClick={() => removeItem(row.id)}
                                className="btn btn-danger shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-trash"></i>
                            </span>
                        )}
                    </OverlayTrigger>
                    {/* <div
                    onClick={()=>goToPage(`/company/policy/create/${row.term}`)}
                        // to={`/company/policy/create/${row.term}`}
                        className="btn btn-info shadow btn-xs sharp me-1"
                    >
                        <i className="fas fa-file-alt"></i>
                    </div> */}

                </>)
            }
        },
    ]
    const [data, setData] = useState([]);
    const [fileData, setFileData] = useState({
        name: "company_list",
        excelData: [],
        hasCustom: false,
        customRows: [{
            customData: [],
            origin: -1, // last row or specified location like 'A1'
        }],
    });

    useEffect(() => {
        getList()
    }, [])

    async function getList() {
        let query = {};
        let res = await getCompanyList(query);
        if (res?.status === 'success') {
            setData([...res.data])
            setFileData({ ...fileData, excelData: [...res.data] })
        } else {
        }
    }

    function removeItem(id) {
        Swal.fire({
            title: translate(props.lang, "deleteConfirmation"),
            text: translate(props.lang, "deleteMessage"),
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await removeCompany(id)
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message)
                    getList();
                } else {
                    promptMessage(lang, 'error', res.message)
                    getList();
                }
            }
        })
    }

    // const goToPage = (page) => {
    //     let url = page;
    //     let arr = []
    
        
    //     if (pageNumber) {
    //       arr.push(`page=${pageNumber}`)
    //     }
    //     if (productPerpage) {
    //       arr.push(`limit=${productPerpage}`)
    //     }
    //     if (arr.length > 0) {
    //       url = url + `?${arr.join('&')}`
    //     }
    //     window.location.href = url;
    // }

    return (
        <>
            <div className="card shadow">
                <div className="card-header">
                    <div>
                        <div onClick={()=>goToPage(`/company/create`, pageNumber, productPerpage, filterInput)} className="btn btn-primary btn-sm rounded-2 py-2">{translate(lang, 'createCompany')}</div>
                    </div>
                </div>
                <div className="card-body">
                    <div id="job_data" className="dataTables_wrapper">
                        <CustomTable
                            lang={props.lang}
                            columns={tableColumns}
                            data={data}
                            excelExport={false}
                            fileData={fileData}
                            history={history}
                            location={location}
                            updatePageNumber={(page) => setPageNumber(page+1)}
                            updatePageLimit={(limit) => setProductPerpage(limit)}
                            pageNumber={pageNumber}
                            pageLimit={productPerpage}
                            updateFilter={(value) => setFilterInput(value)}
                            filterInput={filterInput}
                        ></CustomTable>
                    </div>
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(CompanyList);